import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Link from 'react-router/lib/Link';
import { getSlideLocation } from '../../../../../utils/slideshow';
import { sendAnalyticsEvent, sendDataLayerEvent } from '../../../../../utils/analytics';
import ResponsiveImg from '../../../../common/responsive_img';

import classNames from 'classnames';

const THUMBNAIL_WIDTH = 280;
const THUMBNAIL_HEIGHT = 280;

export default class Thumbnail extends Component {
  handleClick = () => {
    sendAnalyticsEvent(
      'Slideshow',
      'Slide Selection',
      `Slide ${this.props.slideIndex}`
    );
    sendDataLayerEvent('Click', {
      actionType: 'Slide Selection',
      pageModule: 'Slideshow',
      slideshowComponent: 'Slide Thumbnails',
      itemIndex: this.props.slideIndex
    });
    this.props.handleClick();
  }

  img() {
    const { src, ratio, original_width_px, original_height_px } = this.props;
    if (!src) {
      return null;
    }

    const isPortrait = ratio < 1.0;
    return (
      <ResponsiveImg src={src}
        width={isPortrait ? THUMBNAIL_HEIGHT * ratio : THUMBNAIL_WIDTH}
        height={
          isPortrait ? THUMBNAIL_HEIGHT : THUMBNAIL_WIDTH / ratio
        }
        original_width_px={original_width_px}
        original_height_px={original_height_px}
      />
    );
  }

  render() {
    const { slideIndex, type } = this.props;

    return (
      <Link to={getSlideLocation(slideIndex, this.context.location)}
        onClick={this.handleClick}
      >
        <div className={classNames('thumbnail', type)}>
          {this.img()}
        </div>
      </Link>
    );
  }
}


Thumbnail.propTypes = {
  // All section types will pass these in
  handleClick: PropTypes.func.isRequired,
  slideIndex: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,

  // Both image sections and the intro slide will pass these in
  src: PropTypes.string,
  ratio: PropTypes.number,

  // Only image sections will pass these in
  original_width_px: PropTypes.number,
  original_height_px: PropTypes.number
};

Thumbnail.contextTypes = {
  location: PropTypes.object
};
